(() => {
	'use strict';

	angular
		.module('uwAgenda.global')
		.factory(
			'MessagePaginationService',
			[
				'$rootScope',
				'$filter',
				'MessageService',
				'ItemsPerPage',
				MessagePaginationServiceFn
			]);

	function MessagePaginationServiceFn(
        $rootScope,
        $filter,
		MessageService,
        ItemsPerPage) {
		let data = {
			pagination: {
				currentPage: 1,
				itemsPerPage: ItemsPerPage.Default.value,
			},
			results: [],
			total: 0,
			userId: 0,
			showAll: false
		};

        return {
            data: data,
            init: init,
            search: search,
			paginate: paginate
        };

		function search() {
			data.pagination.includeCount = true;
			data.pagination.currentPage = 1;

			return MessageService.list(data.userId, data.pagination.itemsPerPage, data.pagination.currentPage, data.pagination.includeCount, data.showAll).then(result => {
				data.results = result.results;
				data.total = result.total;
			});
		}
		
		function paginate() {
			data.pagination.includeCount = false;

			return MessageService.list(data.userId, data.pagination.itemsPerPage, data.pagination.currentPage, data.pagination.includeCount, data.showAll).then(result => {
				data.results = result.results;
			});
		}
		
		function init(userId, itemsPerPage, showAll) {
			clean();
			data.userId = userId;
			data.pagination.itemsPerPage = itemsPerPage || ItemsPerPage.Default.value;
			data.showAll = !!showAll;
		}

		function clean() {
			data.results = [];
			data.total = 0;
			data.showAll = false;
		}
	}
})();